export enum ChangePasswordStatus {
  Success,
  ExpiredCode,
  MFARequired,
  PasswordsDoNotMatch,
  PasswordViolatesPolicy,
  PasswordAlreadyUsed,
  UnexpectedFailure,
}
